import type {Task, User} from "@project/sdk/admin";
import type {z} from "zod";

import {GetUserResponse} from "@project/sdk/admin/zod";

export const userResponseSchema = GetUserResponse satisfies z.ZodType<User>;
export const taskResponseSchema = GetUserResponse.shape.tasks.element satisfies z.ZodType<Task>;
